import { mediaQueryStyles } from "@newsela/angelou";

import { SEARCH_PAGE_BREAKPOINTS } from "@/search/Langston/SearchPage/SearchPage.constants";
import type { CSSObject } from "@emotion/react";

const { mediaQuery: breakpoint } = mediaQueryStyles;

// This isn't exported from Angelou.
interface ChipGroupStyleOverrides<T> {
  root?: T;
}

export const contentTypesVisibilityCss = {
  display: "flex",
  height: "fit-content",
  justifyContent: "space-between",

  [breakpoint.upTo(SEARCH_PAGE_BREAKPOINTS.MD)]: {
    display: "none",
  },
};

export const chipGroupRootCss: ChipGroupStyleOverrides<CSSObject> = {
  root: {
    display: "flex",
    justifyContent: "center",
    flexWrap: "wrap",
  },
};
